import { Component, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { EventoComponent } from '../evento/evento.component';

@Component({
  selector: 'app-almacen',
  templateUrl: './almacen.component.html',
  styleUrls: ['./almacen.component.scss'],
})
export class AlmacenComponent implements OnInit {
  constructor(
    private router: Router,
    private dialog: MatDialog,
    public dialogRef: MatDialogRef<EventoComponent>
  ) {}

  ngOnInit(): void {}

  openMallModal() {
    const dialogRef = this.dialog.open(AlmacenComponent, {
      autoFocus: false,
      restoreFocus: true,
      hasBackdrop: true,
      data: {},
    });
  }

  onCancel(): void {
    this.dialogRef.close();
  }
}
